import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export const fmtDMY = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join("/") : "");


export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
